import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Button } from "antd";
import { TiUser } from "react-icons/ti";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import { initFilterInput, renderColumns } from "./constants";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import PreviewImage from "../../../components/common/PreviewImage/PreviewImage";
import CustomTable from "../../../components/common/Table/CustomTable";
import Title from "../../../components/common/Title/Title";
import moment from "moment";
import TextInfo from "../../../components/common/TextInfo/TextInfo";
import { convertHistoryPengembalian } from "../helpers/convertHistoryPengembalian";
import CustomDatePicker from "../helpers/CustomDatePicker";
import { GetImage } from "../../../components/helpers/GetImage";

export default function HistoryPengembalian() {
  const [records, setRecords] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [dateValue, setDateValue] = useState([]);
  const [modalDetail, setModalDetail] = useState(false);
  const [loading, setLoading] = useState(false);
  const [filterInput, setFilterInput] = useState(initFilterInput);
  const [tablePagination, setTablePagination] = useState({});
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const [codeGadai, setCodeGadai] = useState("");
  const [namaNasabah, setNamaNasabah] = useState();
  const [notelpNasabah, setNotelpNasabah] = useState();
  const [noImei, setNoImei] = useState();
  const [tanggalKirim, setTanggalKirim] = useState();
  const [waktuKirim, setWaktuKirim] = useState();
  const [alamatKirim, setAlamatKirim] = useState();
  const [kurir, setKurir] = useState();

  const [barangJaminan, setBarangJaminan] = useState();
  const [outletName, setOutletName] = useState();

  // image
  const [sbgImg, setSbgImg] = useState([]);
  const [sbgImg2, setSbgImg2] = useState('');
  const [ktpNasabahImg, setktpNasabahImg] = useState([]);
  const [ktpPenerimaImg, setktpPenerimaImg] = useState();
  const [imgLink, setImgLink] = useState("");
  const [image, setImage] = useState([]);
  const [deliveryPictureId, setDeliveryPictureId] = useState();

  useEffect(() => {
    getData();
  }, [filterInput]);

  const getData = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}gadai/delivery-history`;
    let params = {
      search: filterInput.searchName,
      page: parseInt(filterInput.page),
      size: parseInt(filterInput.pageSize) || 0,
      start_date: filterInput.transactionStartDate,
      end_date: filterInput.transactionEndDate,
    };
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        let data = response.data.data;
        setRecords(convertHistoryPengembalian(data.items));
        setTotalRecords(data.total_item);
        setLoading(false);
        setTablePagination({
          current: response.data.data?.page,
          pageSize: response.data.data?.per_page,
          total: response.data.data?.total_item,
        });
      },
      (error) => {
        console.log(error);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleOpenPreview = (url) => () => {
    setImgLink(url);
    setIsPreviewOpen(true);
  };

  const handleDateChange = (event) => {
    const startDate = moment(event?.[0]?._d).startOf("day");
    const endDate = moment(event?.[1]?._d).startOf("day");

    setDateValue(event ? [startDate, endDate] : null);
    setFilterInput((prev) => ({
      ...prev,
      transactionStartDate: event ? new Date(startDate) : null,
      transactionEndDate: event ? new Date(endDate) : null,
      page: 1,
    }));
  };

  const validate = (data) => {
    const newErrors = {};

    if (!data.sbg || data.sbg === "") {
      newErrors.sbg = "SBG harus diupload";
    }
    if (!data.ktpNasabah || data.ktpNasabah === "") {
      newErrors.ktpNasabah = "Ktp Nasabah harus diupload";
    }
    return newErrors;
  };

  const handleDetail = (record) => {
    setModalDetail(true);
    setCodeGadai(record.kode_gadai);
    setNamaNasabah(record.nama_nasabah);
    setNotelpNasabah(record.no_telp_nasabah);
    setBarangJaminan(record.barang_jaminan);
    setWaktuKirim(record.waktu_kirim);
    setAlamatKirim(record.lokasi_kirim);
    setKurir(record.nama_kurir);
    setOutletName(record.lokasi);
    setTanggalKirim(record.tanggal_kirim_detail);
    setBarangJaminan(record.barang_jaminan);
    setktpNasabahImg(record.ktp_nasabah);
    setktpPenerimaImg(record.ktp_penerima);
    setSbgImg(record.sbg);
    setSbgImg2(record.sbg2);
    setImage(record.image);
    setNoImei(record.imei);
    setDeliveryPictureId(record.gadai_delivery_picture_id);
  };

  const handleCloseModal = () => {
    setCodeGadai();
    setNamaNasabah();
    setNotelpNasabah();
    setBarangJaminan();
    setWaktuKirim();
    setAlamatKirim();
    setKurir();
    setOutletName();
    setTanggalKirim();
    setBarangJaminan();
    setktpNasabahImg();
    setktpPenerimaImg();
    setSbgImg();
    setImage([]);
    setNoImei();
    setModalDetail(false);
  };

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleFilterChanged = (e) => {
    const { value, name } = e.target;
    if (name === "pageSize") {
      setFilterInput((prev) => ({
        ...prev,
        pageSize: parseInt(value),
      }));
    }
    if (name === "name") {
      if (e.key === "Enter" || e.keyCode === 13) {
        setFilterInput((prev) => ({
          ...prev,
          searchName: value,
        }));
      }
    }
  };

  return (
    <>
      <div>
        <div className="p-3">
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div>
              <Title text="Riwayat Pengembalian Barang" />
              <Breadcrumb current="Riwayat Pengembalian Barang" />
            </div>
            <div
              style={{
                padding: 13,
                border: "1px solid #DCDCDC",
                borderRadius: 5,
                height: 50,
                width: 200,
              }}
            >
              <div
                style={{
                  fontSize: 18,
                  color: "#303030",
                }}
              >
                <TiUser
                  style={{ marginBottom: 5, fontSize: 24, color: "#D6D6D6" }}
                />
                <span style={{ fontWeight: 700 }}>{totalRecords}</span> Jadwal
              </div>
            </div>
          </div>
          <div className="d-flex pt-3 mt-2">
            <div className="col-1 pl-0">
              <div>Tampilkan</div>
              <input
                type="number"
                name="pageSize"
                className="form-control border-97A0AE mt-1"
                value={filterInput.pageSize}
                min="1"
                onChange={handleFilterChanged}
              />
            </div>
            <div className="mr-3">
              <div>No. SBG/No. Kwitansi / Nama Nasabah</div>
              <input
                type="text"
                name="name"
                className="form-control border-97A0AE mt-1"
                placeholder="Cari.."
                onChange={handleFilterChanged}
                onKeyDown={handleFilterChanged}
              />
            </div>
            <div>
              <CustomDatePicker
                id={"TanggalJemput"}
                label={"Tanggal Kirim"}
                isRangePicker
                width="60%"
                onInputChange={handleDateChange}
                value={dateValue}
                height="35px"
              />
            </div>
          </div>
          <div className="mt-3">
            <CustomTable
              columns={renderColumns(handleDetail)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
              scrollX={2000}
            />
          </div>
        </div>
      </div>

      {/* Detail  Pengembalian Barang*/}
      <Modal
        className="modal-detail"
        centered
        title="Detail Pengembalian Barang"
        visible={modalDetail}
        onCancel={handleCloseModal}
        footer={""}
      >
        <div>
          <div
            className="row flex-row flex-nowrap"
            style={{ overflow: "auto", width: "500px" }}
          >
            {image.map((item) => (
              <GetImage
                className="rounded mb-2 mr-2"
                url={`gadai-product-picture/${item.id}/picture`}
                style={{ width: "200px" }}
              />
            ))}
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="No. Jemput Gadai" value={codeGadai || "-"} />
          </div>

          <div className="detail-header mb-3">
            <TextInfo title="Nama Nasabah" value={namaNasabah || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo
              title="No. Telepon Nasabah"
              value={notelpNasabah || "-"}
            />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Barang Jaminan" value={barangJaminan || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="No. IMEI" value={noImei || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Tanggal Jemput" value={tanggalKirim || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Waktu Jemput" value={waktuKirim || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Alamat Jemput" value={alamatKirim || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo title="Kurir" value={`${kurir}/${outletName}` || "-"} />
          </div>
          <div className="detail-header mb-3">
            <TextInfo
              title="SBG Pelunasan"
              value={
                (
                  <Button
                    style={{
                      marginLeft: -14,
                      marginTop: -5,
                      color: "#2C465C",
                      fontWeight: "bold",
                    }}
                    onClick={handleOpenPreview(
                      `gadai-delivery-picture/${deliveryPictureId}/sbg-picture`
                    )}
                    type="link"
                  >
                    Lihat File
                  </Button>
                ) || "-"
              }
            />
          </div>
          <div className="detail-header mb-3">
            <TextInfo
              title="SBG Pelunasan 2"
              value={
                (
                  <Button
                    style={{
                      marginLeft: -14,
                      marginTop: -5,
                      color: "#2C465C",
                      fontWeight: "bold",
                    }}
                    onClick={handleOpenPreview(
                      `gadai-delivery-picture/${deliveryPictureId}/sbg2-picture`
                    )}
                    type="link"
                  >
                    {sbgImg2}
                  </Button>
                ) || "-"
              }
            />
          </div>
          <div className="detail-header mb-3">
            <TextInfo
              title="KTP Nasabah"
              value={
                (
                  <Button
                    style={{
                      marginLeft: -14,
                      marginTop: -5,
                      color: "#2C465C",
                      fontWeight: "bold",
                    }}
                    onClick={handleOpenPreview(
                      `gadai-delivery-picture/${deliveryPictureId}/customer-ktp-picture`
                    )}
                    type="link"
                  >
                    Lihat File
                  </Button>
                ) || "-"
              }
            />
          </div>
          <div className="detail-header mb-3">
            <TextInfo
              title="KTP Penerima"
              value={
                (
                  <Button
                    style={{
                      marginLeft: -14,
                      marginTop: -5,
                      color: "#2C465C",
                      fontWeight: "bold",
                    }}
                    onClick={handleOpenPreview(
                      `gadai-delivery-picture/${deliveryPictureId}/receiver-ktp-picture`
                    )}
                    type="link"
                  >
                    Lihat File
                  </Button>
                ) || "-"
              }
            />
          </div>
        </div>
      </Modal>

      <PreviewImage
        visible={isPreviewOpen}
        setVisible={setIsPreviewOpen}
        url={imgLink}
      />
    </>
  );
}
